<!-- Standard-Einbindung wie in der @n8n/chat Doku -->
<div id="n8n-chat"></div>
